import React from 'react';
import './OurStory.css';
import founderImg from '../assets/founder.jpeg';

export default function OurStory() {
  return (
    <div className="container py-5">
      <h2 className="text-center display-5 mb-4 style={{ color: '#E4405F' }} fade-in">Our Story</h2>

      <div className="row align-items-left mb-5">
        <div className="col-md-6 text-left text-md-start fade-in" style={{ animationDelay: '0.1s' }}>
        <h4 className="responsive-header" style={{ color: '#406B60' }}>One Cup. One Love. One Journey.</h4>   
          <p className="text-muted">
            She was a New Yorker — bold, bright, and always chasing the next great cup of tea. He was a Chicago native — thoughtful,
            grounded, and just as obsessed with quality beverages. They met in New York, bonded over their love of specialty drinks,
            and soon, their casual tea dates turned into a lifelong connection.
          </p>
          <p className="text-muted">
            When they moved to Chicago's South Loop to start their next chapter, they brought their love — and their cravings — with them.
            What came next was only natural: Habibtea, a mobile beverage cart born from their shared passion and a desire to spread joy.
            With a carefully curated selection of Mocktails, Dirty Sodas, and Boba, Habibi means "my love" in Arabic — a perfect reflection of the couple behind it: love, quality, and community. With every event they serve, they pour a little of their story into each cup — whether it's a
            wedding, a celebration, or a sunny weekend pop-up.
          </p>
          <p className="text-muted">
            Habibtea isn't just a beverage service — it's their love story, crafted fresh and shared one unforgettable cup at a time.
          </p>
        </div>

        <div className="col-md-6 text-left fade-in" style={{ animationDelay: '0.2s' }}>
          <img src={founderImg} alt="Founder" className="img-fluid rounded shadow-sm story-image" />
        </div>
      </div>

      <div className="text-left text-muted fade-in" style={{ animationDelay: '0.3s' }}>
        <em>"Habibi" means "my love" in Arabic — and everything we craft is made with love.</em>
      </div>
    </div>
  );
}
